export class ParametroSistema {
    constructor ( 
        public readonly Codigo: string | null, 
        public readonly Valor: string | null, 
        public readonly Comentarios: string | null, 
        public readonly PermitirAccederAnonimamente: boolean,
        public readonly PuedeEditarCodigo: boolean,
        public readonly Id: number  
    ) {}
}

export class SearchParametroSistemaRequestDto {
    constructor( 
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null, 
        public readonly Nombre: string | null, 
        public readonly VerSoloPermitirAccederAnonimamente: boolean | null
    ){}
}

export class SearchParametroSistemaResponseDto {
    constructor( 
        public readonly Total: number, 
        public readonly Items: ParametroSistema[]
    ){}
}